<template>
	<div>
		<div class="logReg__loginWrapper" id="loginForm">
			<div class="bold">{{ $t('buyout.give_registration_number') }}</div>
			<v-text-field
				v-model="input"
				:error-messages="this.buyoutLoadError"
				@keyup.native.enter="Login"
				v-on:input="isEditing = true"
			></v-text-field>
			<v-btn
				text
				:ripple="false"
				asign="center"
				@click="Login"
				:loading="loading"
				:disabled="(stateLoggedIn || !input) && !isEditing"
			>
				{{ $t('buyout.logRegSwapper.log_in') }}
			</v-btn>
			<div v-if="stateLoggedIn">
				<slot name="loginBuyout">
					<online-buyout-only v-if="isOnlyOnlineBuyout" />
					<buyout v-if="!isOnlyOnlineBuyout" />
				</slot>
			</div>
		</div>
	</div>
</template>

<script>
import { VUEX_BUYOUT } from '../../../store/buyout';
import { mapGetters, mapMutations, mapActions, mapState} from 'vuex';
import { config } from '../../../config/buyout';
import { sleep } from '../../../../js/buyout';
import { GETTER_TYPES } from '../../../store/buyout/_getter-types';
import { MUTATION_TYPES } from '../../../store/buyout/_mutation-types';
import { ACTION_TYPES } from '../../../store/buyout/_action-types';

export default {
	name: 'LoginForm',
	components: {
		OnlineBuyoutOnly: () => import('../OnlineBuyoutOnly/App'),
		Buyout: () => import('../Buyout/App')
	},
	computed: {
		...mapState(VUEX_BUYOUT.NAMESPACE,[
			'buyoutLoadError'
		]),
		...mapGetters(VUEX_BUYOUT.NAMESPACE, [
			GETTER_TYPES.IS_LOGGED_IN,
			GETTER_TYPES.USER_BUYOUT_CODE
		]),
		stateLoggedIn: {
			get() {
				return this[GETTER_TYPES.IS_LOGGED_IN];
			},
			set(v) {
				this[MUTATION_TYPES.SET_IS_LOGGED_IN](v);
			}
		},
		stateUserBuyoutCode: {
			get() {
				return this[GETTER_TYPES.USER_BUYOUT_CODE];
			},
			set(v) {
				this[MUTATION_TYPES.SET_USER_BUYOUT_CODE](v);
			}
		},
		isOnlyOnlineBuyout: () => config.isOnlyOnlineBuyout
	},
	data() {
		return {
			input: this.stateUserBuyoutCode,
			loading: false,
			isEditing: false
		}
	},
	mounted() {
		this.input = this.stateUserBuyoutCode
	},
	methods: {
		...mapMutations(VUEX_BUYOUT.NAMESPACE, [
			MUTATION_TYPES.SET_USER_BUYOUT_CODE,
			MUTATION_TYPES.SET_IS_LOGGED_IN,
			MUTATION_TYPES.SET_IS_REGISTRATION
		]),
		...mapActions(VUEX_BUYOUT.NAMESPACE, [
			ACTION_TYPES.LOAD_BUYOUT]),
		async Login() {
			this.loading = true;
			this.stateUserBuyoutCode = this.input;
			this[MUTATION_TYPES.SET_IS_REGISTRATION](false);

			if (
				config.isURLHandlingEnabled &&
				this.stateUserBuyoutCode !== this.$route.params.userBuyoutCode
			)
				this.$router.push({
					name: 'buyout',
					params: {
						userBuyoutCode: this.stateUserBuyoutCode
					}
				});

			await this[ACTION_TYPES.LOAD_BUYOUT]();
			if (!this.buyoutLoadError) {
				this.stateLoggedIn = true;
				this.isEditing = false;
				await sleep(100);
				this.$scrollTo('#device-sum', 500);
			}
			this.loading = false;
		}
	}
}
</script>
